import { Order } from '@cemex-core/cmx-api';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderOptionFilter',
  pure: false,
})
export class OrderOptionsFilterPipe implements PipeTransform {
  transform(items: Order[], filterFn: (order: Order) => boolean): any {
    return items && items.filter(item => filterFn(item));
  }
}
